import { type FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@dr.pogodin/react-utils';
import { captureException } from '@sentry/react';

import Throbber from 'components/Throbber';

import { AdminPage } from 'components/admin';

import NamesAndEmailsInputBlock, {
  type InputStateT,
} from 'components/admin/NamesAndEmailsInputBlock';

import { createAdminUser } from 'services/user';

import { P_ADMIN_ADMIN_USERS, useGlobalState, useGlobalStateObject } from 'utils';

import IconInfo from 'assets/images/icon-info-20px.svg';

import secondaryButtonTheme from 'themes/Button/admin/secondary.scss';

import S from './style.scss';

const AdminAddNewAdminPage: FunctionComponent = () => {
  const [busy, setBusy] = useState(false);
  const [, setModal] = useGlobalState('ui.addNewAdmin.modal');

  const [inputState, setInputState] = useState<InputStateT>({
    email: '',
    firstName: '',
    lastName: '',
    valid: false,
  });

  const navigate = useNavigate();

  const gs = useGlobalStateObject();

  return (
    <AdminPage
      contentClassName={S.wrapper}
      subTitle="Admin Users / Add New Admin"
      title="Add New Admin"
    >
      <div className={S.container}>
        <h3>Admin Information</h3>
        <NamesAndEmailsInputBlock
          setState={setInputState}
          state={inputState}
        />
        <div styleName="info">
          <IconInfo />
          Admin will receive an invitation in order to complete their profile
          and login credentials.
        </div>
        <div styleName="buttons">
          <Button
            theme={secondaryButtonTheme}
            to={P_ADMIN_ADMIN_USERS}
          >
            Cancel and Return
          </Button>
          <Button
            disabled={!inputState.valid}
            onClick={() => {
              void (async () => {
                try {
                  setBusy(true);

                  const res = await createAdminUser(inputState);

                  let list = gs.get('adminUsers.data');
                  if (list) {
                    const idx = list.findIndex(
                      (item) => item.id === res.user.id,
                    );
                    if (idx >= 0) {
                      list = [...list];
                      list[idx] = res.user;
                    } else list = [res.user, ...list];
                  } else list = [res.user];

                  gs.set('adminUsers.data', list);

                  setModal(res.new ? 'CREATED_NEW' : 'PROMOTED_EXISTING');
                } catch (error) {
                  captureException(error);
                  setModal('ERROR');
                }

                setBusy(false);
                void navigate(P_ADMIN_ADMIN_USERS);
              })();
            }}
          >
            Create Admin User
          </Button>
        </div>
      </div>
      {busy ? <Throbber withDebounce withOverlay /> : null}
    </AdminPage>
  );
};

export default AdminAddNewAdminPage;
